/**
 * Which contact form was actually submitted.
 *
 * Shopify's `form.posted_successfully?` is a property of the *page*, not of a
 * form: after any contact post it is true for every contact form rendered, and
 * there are three -- the support widget in the layout, so on every page, plus
 * the quote dialog and the refund form. Submitting the refund form therefore
 * also fired the support widget's confirmation and popped its modal open.
 *
 * Liquid cannot tell them apart. The only discriminator is the fragment
 * Shopify redirects to, `?contact_posted=true#RefundContactForm`, and a
 * fragment is never sent to the server -- so the attribution happens here,
 * once, rather than three times in three snippets.
 *
 * WHY THIS IS A FILE AND NOT AN INLINE SCRIPT
 *
 * It was inline, at the end of <body>, and it silently stopped running on
 * product pages: window.themePostedContactForm came back undefined while both
 * confirmations survived. The element was present and its syntax was valid --
 * the give-away was its `type`, rewritten from nothing to "text/javascript",
 * which is Cookiebot's auto-blocking signature. Auto-blocking re-types a
 * script to text/plain to hold it, and restoring the type afterwards does not
 * re-execute it, so the script was in the DOM and dead. It varied run to run:
 * three inline scripts blocked on one load, none on the next.
 *
 * An external file with data-cookieconsent="ignore" is exempt from that. The
 * attribute is deliberately on this script only -- Cookiebot's own
 * documentation warns that applying it to a script that would not have been
 * blocked can interfere with the auto-blocker and break the page, so it is not
 * something to spray across the layout.
 *
 * ES5 and `var` to match the theme's other scripts.
 */
(function () {
  var successes = [].slice.call(document.querySelectorAll('[data-contact-success]'));
  if (!successes.length) {
    window.themePostedContactForm = null;
    return;
  }

  var posted = (window.location.hash || '').replace('#', '');

  // One confirmation on the page is unambiguous whatever the fragment says.
  if (successes.length === 1) {
    posted = successes[0].getAttribute('data-contact-success');
  }

  // No fragment and more than one confirmation: keep them all. Removing them
  // would be worse -- the shopper submitted something and would be shown
  // nothing at all. Shopify's redirect always carries the fragment, so this is
  // a defensive branch rather than an expected one.
  if (!posted) {
    window.themePostedContactForm = null;
    return;
  }

  successes.forEach(function (el) {
    if (el.getAttribute('data-contact-success') === posted) return;
    // Removed, not hidden: a stray role="status" message left in the DOM is
    // still announced by a screen reader.
    if (el.parentNode) el.parentNode.removeChild(el);
  });

  // The submitted form hides its own fields; the others keep theirs, which is
  // the point -- the support widget stays usable after a different form posts.
  var fields = document.querySelector('[data-contact-fields="' + posted + '"]');
  if (fields) fields.hidden = true;

  // Focus the surviving confirmation here rather than with `autofocus`, which
  // fires before this runs and would land on a message about to be removed.
  var survivor = document.querySelector('[data-contact-success="' + posted + '"]');
  if (survivor) {
    try { survivor.focus({ preventScroll: true }); } catch (e) {}
  }

  window.themePostedContactForm = posted;
})();
